(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catering-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var storageKey = 'babaCateringOption';

    function getOptionField() {
      return (
        document.querySelector('[data-catering-option-field]') ||
        document.querySelector('#catering-form [name="contact[catering_option]"]') ||
        document.querySelector('[name="contact[catering_option]"]') ||
        document.getElementById('catering_option')
      );
    }

    function setCateringOption(value) {
      var select = getOptionField();
      if (!select || !value) return;
      select.value = value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      try {
        sessionStorage.setItem(storageKey, value);
      } catch (error) {}
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-catering-option]');
      if (!link) return;
      setCateringOption(link.getAttribute('data-catering-option'));
    });

    function restoreCateringOption() {
      if (window.location.hash.indexOf('catering-request') === -1) return;
      var stored = '';
      try {
        stored = sessionStorage.getItem(storageKey) || '';
      } catch (error) {}
      if (stored) setCateringOption(stored);
    }

    window.addEventListener('hashchange', restoreCateringOption);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', restoreCateringOption);
    } else {
      restoreCateringOption();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
